import { Link } from 'react-router-dom';
import { PartnerEndpoints } from '../../../utils/endpoints';
import { Permissions } from '../../../utils/permissions';
import { useAuth } from '../../../AuthContext';
import PageHeader from '../../shell/PageHeader';
import WithdrawalsTable from './sub-merchant/WithdrawalsTable';

const SubMerchantWithdrawals = () => {
  const { hasPermission } = useAuth();

  return (
    <>
      <PageHeader title="Withdrawals" breadcrumbs={[{ label: 'Home', to: '/layout' }, { label: 'Withdrawals' }]} />
      <p className="mb-6 text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
        CashCard withdraws everything above ₦1,000 in your ledger to your bank account, less transfer fees, once at
        least ₦10,000 can be sent. You can't start a withdrawal here.{' '}
        {hasPermission(Permissions.subMerchantBankAccountView) && (
          <Link to="/layout/sub-merchant-bank-account" className="text-primary-500 hover:underline">
            Check your bank account
          </Link>
        )}
      </p>
      <WithdrawalsTable endpoint={PartnerEndpoints.ownWithdrawals} />
    </>
  );
};

export default SubMerchantWithdrawals;
